import { render } from "./CollectionDetailedSearchHistoricalRecording.vue?vue&type=template&id=5f8af17e&scoped=true&ts=true"
import script from "./CollectionDetailedSearchHistoricalRecording.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchHistoricalRecording.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchHistoricalRecording.vue?vue&type=style&index=0&id=5f8af17e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8af17e"]])

export default __exports__